import { render, staticRenderFns } from "./MainOptions.vue?vue&type=template&id=08ae96aa&"
import script from "./MainOptions.vue?vue&type=script&lang=js&"
export * from "./MainOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports